/** Exam status / profile helpers. Types come from ExamType master API. */

export const EXAM_STATUSES = [
  "DRAFT",
  "PUBLISHED",
  "ONGOING",
  "COMPLETED",
  "RESULTS_PUBLISHED",
];

/**
 * Must match backend SCHEDULE_STATUSES in examControllers.js
 * POSTPONED is set only via postpone API (not status API).
 */
export const SCHEDULE_STATUSES = [
  "SCHEDULED",
  "NEEDS_REVIEW",
  "POSTPONED",
  "COMPLETED",
  "CANCELLED",
  "RESCHEDULED",
  "HELD",
];

/** Allowed next statuses for schedule status API (mirrors backend) */
export const ALLOWED_SCHEDULE_STATUS_TRANSITIONS = {
  SCHEDULED: ["NEEDS_REVIEW", "CANCELLED", "COMPLETED"],
  NEEDS_REVIEW: ["COMPLETED", "CANCELLED", "SCHEDULED"],
  POSTPONED: ["SCHEDULED", "CANCELLED"],
  RESCHEDULED: ["SCHEDULED", "CANCELLED", "COMPLETED"],
  HELD: [],
  COMPLETED: [],
  CANCELLED: [],
};

/** Statuses that may use postpone API */
export const POSTPONABLE_SCHEDULE_STATUSES = [
  "SCHEDULED",
  "NEEDS_REVIEW",
  "POSTPONED",
  "RESCHEDULED",
];

/** Statuses that block schedule edit/delete */
export const LOCKED_SCHEDULE_STATUSES = ["COMPLETED", "CANCELLED", "HELD"];

export const SEATING_PLAN_STATUSES = ["DRAFT", "FINAL"];

/** Prefer exam.scheduleProfile from backend; fallback legacy codes */
export const isFullProfile = (typeOrExam) => {
  if (!typeOrExam) return false;
  if (typeof typeOrExam === "object") {
    if (typeOrExam.scheduleProfile === "FULL") return true;
    if (typeOrExam.scheduleProfile === "LIGHT") return false;
    typeOrExam = typeOrExam.type;
  }
  const legacyFull = ["FA", "SA", "HALF_YEARLY", "ANNUAL"];
  return legacyFull.includes(typeOrExam);
};

export const EXAM_STATUS_LABELS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
  ONGOING: "Ongoing",
  COMPLETED: "Completed",
  RESULTS_PUBLISHED: "Results Published",
};

export const EXAM_STATUS_COLORS = {
  DRAFT: "bg-gray-100 text-gray-600",
  PUBLISHED: "bg-blue-100 text-blue-700",
  ONGOING: "bg-yellow-100 text-yellow-800",
  COMPLETED: "bg-green-100 text-green-700",
  RESULTS_PUBLISHED: "bg-emerald-100 text-emerald-700",
};

export const SCHEDULE_STATUS_LABELS = {
  SCHEDULED: "Scheduled",
  NEEDS_REVIEW: "Needs review",
  POSTPONED: "Postponed",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  RESCHEDULED: "Rescheduled",
  HELD: "Held",
};

export const SCHEDULE_STATUS_COLORS = {
  SCHEDULED: "bg-blue-100 text-blue-700",
  NEEDS_REVIEW: "bg-amber-100 text-amber-800",
  POSTPONED: "bg-orange-100 text-orange-700",
  COMPLETED: "bg-green-100 text-green-700",
  CANCELLED: "bg-red-100 text-red-700",
  RESCHEDULED: "bg-orange-100 text-orange-700",
  HELD: "bg-green-100 text-green-700",
};

export const EXAM_TYPE_COLORS = {
  FA: "bg-blue-100 text-blue-700",
  SA: "bg-purple-100 text-purple-700",
  UNIT_TEST: "bg-green-100 text-green-700",
  CLASS_TEST: "bg-yellow-100 text-yellow-800",
  HALF_YEARLY: "bg-orange-100 text-orange-700",
  ANNUAL: "bg-red-100 text-red-700",
  OTHER: "bg-gray-100 text-gray-600",
};

export const ALLOWED_STATUS_TRANSITIONS = {
  DRAFT: ["PUBLISHED"],
  PUBLISHED: ["ONGOING", "DRAFT"],
  ONGOING: ["COMPLETED", "PUBLISHED"],
  COMPLETED: ["RESULTS_PUBLISHED"],
  RESULTS_PUBLISHED: [],
};
